import { makeStyles } from '@material-ui/core'

// ONE constant shared by tableHead, tableRow and the skeleton, per
// docs/admin-panel/portal-ux-conventions.md section 2 — the three cannot drift apart, and
// a skeleton built on a different grid causes a layout jump the moment data arrives.
//
// `minmax(0, Nfr)` rather than a bare `Nfr`: a bare track is `minmax(auto, Nfr)`, whose
// floor is min-content, so an unbreakable token — a voucher code or a booking id, both of
// which are exactly that — pushes its track past its share and misaligns every other
// column. The promotions list shipped that defect and it was reported as "the rows are
// messed up". The trailing `auto` is the state chip, which is content-sized on purpose.
const COLUMNS = 'minmax(0, 6fr) minmax(0, 5fr) minmax(0, 5fr) auto'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    minHeight: 56,
    alignItems: 'center',
    padding: '0 12px',
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    marginBottom: 4
  },
  // minWidth 0 as well as the track floor: a grid ITEM has its own min-content floor, so
  // the track fix alone does not stop the text painting over its neighbour.
  cell: {
    minWidth: 0,
    paddingRight: 12,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  refreshCell: { margin: 'auto' },
  // Matches the surrounding VoucherUpload panels so the audit reads as another section of
  // the same screen rather than a transplant.
  paper: { padding: theme.spacing(2), marginTop: theme.spacing(2) },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2)
  },
  noDataImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 62
  },
  totals: {
    display: 'flex',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1)
  },
  skeleton: { width: '80%' }
}))

export default useStyles
